<template>
    <b-form @submit.prevent="openModalConfirm">
        <div class="form-parameter-wrapper">
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Grace Period / Toleransi" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-form-input v-model="dendaPenaltiInput.GRACE_PERIOD" name="toleransiHari" type="number" required></b-form-input>
                        <span class="smallText text-muted">Tambahan hari untuk toleransi keterlambatan pembayaran, sebelum dikenakan denda </span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Persentase Denda Elektronik" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group append="%">
                            <b-form-input required v-model="dendaPenaltiInput.DENDA_ELEK" id="persenDendaElek" name="persenDendaElektronik" step="0.01" @blur="roundPersen(1)" type="number"></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Persentase denda per perpanjangan untuk keterlambatan gadai elektronik</span>
                    </b-col>
                </b-row>
                <b-popover target="persenDendaElek" title="Catatan" triggers="focus" placement="topleft">
                    <ul class="tooltip-content-wrapper list-popover-wrapper">
                        <li class="mb-2">
                            Persentase berdasarkan pokok pinjaman.
                        </li>
                        <li class="mb-2">
                            Bila input adalah 10%, maka artinya 10% dari pokok pinjaman.
                        </li>
                    </ul>
                </b-popover>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Persentase Denda Kendaraan" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group append="%">
                            <b-form-input required v-model="dendaPenaltiInput.DENDA_KEND" id="persenDendaKend" name="persenDendaKendaraan" step="0.01" @blur="roundPersen(2)" type="number"></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Persentase denda per pembayaran untuk keterlambatan gadai kendaraan</span>
                    </b-col>
                </b-row>
                <b-popover target="persenDendaKend" title="Catatan" triggers="focus" placement="topleft">
                    <ul class="tooltip-content-wrapper list-popover-wrapper">
                        <li class="mb-2">
                            Persentase berdasarkan pokok pinjaman.
                        </li>
                        <li class="mb-2">
                            Bila input adalah 10%, maka artinya 10% dari pokok pinjaman.
                        </li>
                    </ul>
                </b-popover>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Persentase Denda BPKB" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group append="%">
                            <b-form-input required v-model="dendaPenaltiInput.DENDA_BPKB" id="persenDendaBpkb" name="persenDendaBpkbBulanan" step="0.01" @blur="roundPersen(3)" type="number"></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Persentase denda per bulan untuk keterlambatan gadai BPKB</span>
                    </b-col>
                </b-row>
                <b-popover target="persenDendaBpkb" title="Catatan" triggers="focus" placement="topleft">
                    <ul class="tooltip-content-wrapper list-popover-wrapper">
                        <li class="mb-2">
                            Persentase berdasarkan pokok pinjaman.
                        </li>
                        <li class="mb-2">
                            Bila input adalah 10%, maka artinya 10% dari pokok pinjaman.
                        </li>
                    </ul>
                </b-popover>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Biaya Penalti Elektronik" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group prepend="Rp">
                            <b-form-input v-model="dendaPenaltiInput.MIN_PENALTI_ELEK" name="biayaPenaltiElektronik" required></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Minimum pinjaman yang dikenakan penalti elektronik, untuk pembayaran gadai elektronik yang sudah masuk dalam order lelang</span>
                    </b-col>
                    <b-col>
                        <b-input-group prepend="Rp">
                            <b-form-input v-model="dendaPenaltiInput.PENALTI_ELEK" name="biayaPenaltiElektronik" required></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Penalti yang dikenakan untuk pembayaran gadai elektronik yang sudah masuk dalam order lelang</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Penalti Kendaraan Mobil" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group prepend="Rp">
                            <b-form-input v-model="dendaPenaltiInput.PENALTI_KEND_MBL" name="biayaPenaltiMobil" required></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Biaya penalti yang dikenakan untuk pembayaran gadai kendaraan mobil yang terlambat</span>
                    </b-col>
                    <b-col>
                        <b-form-input v-model="dendaPenaltiInput.PENALTI_KEND_MBL_BULAN" name="bulanPenaltiMobil" type="number" required></b-form-input>
                        <span class="smallText text-muted">Bulan keterlambatan sebelum dikenakan penalti</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Penalti Kendaraan Motor" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group prepend="Rp">
                            <b-form-input v-model="dendaPenaltiInput.PENALTI_KEND_MTR" name="biayaPenaltiMotor" required></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Biaya penalti yang dikenakan untuk pembayaran gadai kendaraan motor yang terlambat</span>
                    </b-col>
                    <b-col>
                        <b-form-input v-model="dendaPenaltiInput.PENALTI_KEND_MTR_BULAN" name="bulanPenaltiMotor" type="number" required></b-form-input>
                        <span class="smallText text-muted">Bulan keterlambatan sebelum dikenakan penalti</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Penalti BPKB Mobil" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group prepend="Rp">
                            <b-form-input v-model="dendaPenaltiInput.PENALTI_BPKB_MBL" name="biayaPenaltiBpkbMobil" required></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Biaya penalti yang dikenakan untuk pembayaran gadai BPKB mobil yang terlambat</span>
                    </b-col>
                    <b-col>
                        <b-form-input v-model="dendaPenaltiInput.PENALTI_BPKB_MBL_BULAN" name="bulanPenaltiBpkbMobil" type="number" required></b-form-input>
                        <span class="smallText text-muted">Bulan keterlambatan sebelum dikenakan penalti</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Penalti BPKB Motor" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group prepend="Rp">
                            <b-form-input v-model="dendaPenaltiInput.PENALTI_BPKB_MTR" name="biayaPenaltiBpkbMotor" required></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Biaya penalti yang dikenakan untuk pembayaran gadai BPKB motor yang terlambat</span>
                    </b-col>
                    <b-col>
                        <b-form-input v-model="dendaPenaltiInput.PENALTI_BPKB_MTR_BULAN" name="bulanPenaltiBpkbMotor" type="number" required></b-form-input>
                        <span class="smallText text-muted">Bulan keterlambatan sebelum dikenakan penalti</span>
                    </b-col>
                </b-row>
            </b-form-group>
        </div>
        <div class="form-wrapper-btn submit-btn-wrapper">
            <b-button type="submit" name="parameterUpdateBtn" variant="pgiBtn">Update</b-button>
        </div>
        <ModalConfirm id="modal-edit-dendaPenalti" title="Confirm Edit Parameter Denda & Penalti" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengubah parameter denda penalti ini?" @submit="onSubmit" />
    </b-form>
</template>

<script>
export default {
    name: 'denda-penalti',
    props: {
        dendaPenaltiInput: { type: Object, required: true }
    },
    data(){
        return{
            isSubmitting: false,
            newData: {}
        }
    },
    watch: {
        "dendaPenaltiInput.PENALTI_ELEK": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.dendaPenaltiInput.PENALTI_ELEK = result);
        },
        "dendaPenaltiInput.MIN_PENALTI_ELEK": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.dendaPenaltiInput.MIN_PENALTI_ELEK = result);
        },
        "dendaPenaltiInput.PENALTI_KEND_MBL": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.dendaPenaltiInput.PENALTI_KEND_MBL = result);
        },
        "dendaPenaltiInput.PENALTI_KEND_MTR": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.dendaPenaltiInput.PENALTI_KEND_MTR = result);
        },
        "dendaPenaltiInput.PENALTI_BPKB_MBL": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.dendaPenaltiInput.PENALTI_BPKB_MBL = result);
        },
        "dendaPenaltiInput.PENALTI_BPKB_MTR": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.dendaPenaltiInput.PENALTI_BPKB_MTR = result);
        },
    },
    methods: {
        //----------------- Fungsi Submit Data -----------------

        onSubmit() {
            this.newData = JSON.parse(JSON.stringify(this.dendaPenaltiInput))
            
            const biayaPenaltiElektronik = this.$helper.removeThousandSeparator(this.newData.PENALTI_ELEK);
            this.newData.PENALTI_ELEK = biayaPenaltiElektronik;
            const minBiayaPenaltiElektronik = this.$helper.removeThousandSeparator(this.newData.MIN_PENALTI_ELEK);
            this.newData.MIN_PENALTI_ELEK = minBiayaPenaltiElektronik;
            const biayaPenaltiMobil = this.$helper.removeThousandSeparator(this.newData.PENALTI_KEND_MBL);
            this.newData.PENALTI_KEND_MBL = biayaPenaltiMobil;
            const biayaPenaltiMotor = this.$helper.removeThousandSeparator(this.newData.PENALTI_KEND_MTR);
            this.newData.PENALTI_KEND_MTR = biayaPenaltiMotor;
            const biayaPenaltiBpkbMobil = this.$helper.removeThousandSeparator(this.newData.PENALTI_BPKB_MBL);
            this.newData.PENALTI_BPKB_MBL = biayaPenaltiBpkbMobil;
            const biayaPenaltiBpkbMotor = this.$helper.removeThousandSeparator(this.newData.PENALTI_BPKB_MTR);
            this.newData.PENALTI_BPKB_MTR = biayaPenaltiBpkbMotor;

            let payload = new FormData()
            
            for (let [key, value] of Object.entries(this.newData)) {
                payload.append("name", key)
                payload.append("value", value)
            }

            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true
            
            this.$axios.post("parameter/update/", payload).then(response => {
                this.$helper.toastSucc(this, "Parameter Denda & Penalti telah berhasil diubah!")
                this.$bvModal.hide("modal-edit-dendaPenalti")
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },
        
        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------
        
        openModalConfirm(){
            this.$bvModal.show("modal-edit-dendaPenalti")
        },

        roundPersen(id){
            if(id == 1){
                var persenDendaElektronik = Number(this.dendaPenaltiInput.DENDA_ELEK).toFixed(2);
                this.dendaPenaltiInput.DENDA_ELEK = persenDendaElektronik;
            }else if(id == 2){
                var persenDendaKendaraan = Number(this.dendaPenaltiInput.DENDA_KEND).toFixed(2);
                this.dendaPenaltiInput.DENDA_KEND = persenDendaKendaraan;
            }else{
                var persenDendaBpkbBulanan = Number(this.dendaPenaltiInput.DENDA_BPKB).toFixed(2);
                this.dendaPenaltiInput.DENDA_BPKB = persenDendaBpkbBulanan;
            }
        }
    },
    created(){
    }
}
</script>